import {
  FontSelect as baseFontSelect,
  FontColor as baseFontColor,
  FontStyleSelect as baseFontStyleSelect,
  FontSize as baseFontSize,
  VerticalAlignment as baseVerticalAlignment,
  HorizontalAlignment as baseHorizontalAlignment,
  BackgroundColor as defaultBackgroundColorConfig,
} from 'apps/studio/components/settings/fields/Base/design'

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

import { TextIcon } from '@gocanvas/gcds/icons'

const FontSelect = {
  ...baseFontSelect,
  updateType: 'pageStyles',
}

const FontColor = {
  ...baseFontColor,
  updateType: 'pageStyles',
}

const FontStyleSelect = {
  ...baseFontStyleSelect,
  updateType: 'pageStyles',
}

const FontSize = {
  ...baseFontSize,
  updateType: 'pageStyles',
}

export const VerticalAlignment = {
  ...baseVerticalAlignment,
  updateType: 'pageStyles',
}

export const HorizontalAlignment = {
  ...baseHorizontalAlignment,
  updateType: 'pageStyles',
}

export const BackgroundColor = {
  ...defaultBackgroundColorConfig,
  updateType: 'pageStyles',
}

export const typographySettings = [
  SettingsLabel('Font'),
  FontSelect,
  FontSize,
  FontStyleSelect,
  FontColor,
  SettingsLabel('Alignment'),
  HorizontalAlignment,
  VerticalAlignment,
]

export const DESIGN_SETTINGS_PANEL = 'Typography'

export const DesignSettingsPanel = {
  label: DESIGN_SETTINGS_PANEL,
  icon: TextIcon,
  settings: typographySettings,
}
